import React, { Component } from 'react';

export default class GooglePlusWidget extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // TODO: Load gapi using this component, and wait for the load to fire it
    if (global.gapi) {
      global.gapi.page.go();
    }
  }

  render() {
    return (
      <div className="pull-right">
        <div
          className="g-page"
          data-href="https://plus.google.com/113593382960179528928"
          data-rel="publisher"
        />
      </div>
    );
  }
}
